package org.matthewo.recharts.type

object LineType {

    val basis: LineType
        get() = "basis".unsafeCast<LineType>()

    val basisClosed: LineType
        get() = "basisClosed".unsafeCast<LineType>()

    val basisOpen: LineType
        get() = "basisOpen".unsafeCast<LineType>()

    val bumpX: LineType
        get() = "bumpX".unsafeCast<LineType>()

    val bumpY: LineType
        get() = "bumpY".unsafeCast<LineType>()

    val bump: LineType
        get() = "bump".unsafeCast<LineType>()

    val linear: LineType
        get() = "linear".unsafeCast<LineType>()

    val linearClosed: LineType
        get() = "linearClosed".unsafeCast<LineType>()

    val natural: LineType
        get() = "natural".unsafeCast<LineType>()

    val monotoneX: LineType
        get() = "monotoneX".unsafeCast<LineType>()

    val monotoneY: LineType
        get() = "monotoneY".unsafeCast<LineType>()

    val monotone: LineType
        get() = "monotone".unsafeCast<LineType>()

    val step: LineType
        get() = "step".unsafeCast<LineType>()

    val stepBefore: LineType
        get() = "stepBefore".unsafeCast<LineType>()

    val stepAfter: LineType
        get() = "stepAfter".unsafeCast<LineType>()
}
